import { FunctionComponent, useEffect, useState } from 'react'
import { Location, useLocation } from 'react-router-dom'
import GroupList from './groupList/groupList'
import GroupProfile from './groupProfile/groupProfile'
import styles from './group.module.scss'
import Loading from '@/components/Loading/Loading'
import { useQuery } from '@apollo/client'
import { GET_DAYCARE_GROUPS } from '@/modules/API/daycareGroup/daycareGroupHandler'
import { DaycareGroup } from '@/types/DaycareGroup'

const Groups: FunctionComponent = () => {
    const urlDaycare: Location = useLocation()
    const paramDaycare: URLSearchParams = new URLSearchParams(urlDaycare.search)

    const [groupList, setGroupList] = useState<Array<DaycareGroup>>([])
    const [groupId, setGroupId] = useState<number | null>(
        paramDaycare.get('group') === null ? null : Number(paramDaycare.get('group'))
    )

    useEffect(() => {
        setGroupId(paramDaycare.get('group') === null ? null : Number(paramDaycare.get('group')))
    }, [urlDaycare])

    const { loading: loadingGroups, data: dataGroups, refetch: refetchGroups } = useQuery(GET_DAYCARE_GROUPS)

    useEffect(() => {
        if (dataGroups) {
            setGroupList(dataGroups.getDaycareGroups)
            if (dataGroups.getDaycareGroups.length === 1) {
                setGroupId(dataGroups.getDaycareGroups[0].id)
            }
        }
    }, [dataGroups])

    async function refetchAllGroups(): Promise<void> {
        const { data } = await refetchGroups()
        if (data) {
            setGroupList([])
            setGroupList(data.getDaycareGroups)
            if (data.getDaycareGroups.length === 1) {
                setGroupId(data.getDaycareGroups[0].id)
            }
        }
    }

    useEffect(() => {
        if (groupId === null && groupList.length === 1) {
            setGroupId(groupList[0].id)
        }
    }, [groupId])

    return (
        <div className={styles.PagePosition}>
            {loadingGroups && <Loading overall={false} />}
            {dataGroups && (
                <>
                    {groupId === null ? (
                        <GroupList groupList={groupList} refetchGroups={refetchAllGroups} />
                    ) : (
                        <GroupProfile
                            group={groupList.find((group) => group.id === groupId)}
                            refetchGroups={refetchAllGroups}
                        />
                    )}
                </>
            )}
        </div>
    )
}

export default Groups
